'use client';

export { ErrorPageSport as default } from '@svenskaspelab/nova-foundation/nextjs/pages';
